var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0.89,3.28c0-0.3,0.21-0.55,0.51-0.6c2.55-0.4,6.03-0.69,10.82-0.69c5.17,0,8.86,0.99,11.33,2.97 c2.37,1.87,3.96,4.95,3.96,8.58c0,3.63-1.21,6.71-3.41,8.8c-2.86,2.69-7.1,3.9-12.05,3.9c-0.81,0-1.55-0.03-2.2-0.09 c-0.36-0.03-0.66,0.25-0.66,0.6v11.97c0,0.34-0.27,0.61-0.61,0.61H1.5c-0.34,0-0.61-0.27-0.61-0.61V3.28z M9.2,19.09 c0,0.3,0.22,0.56,0.51,0.6c0.62,0.09,1.36,0.12,2.29,0.12c4.46,0,7.21-2.25,7.21-6.05c0-3.41-2.37-5.45-6.55-5.45 c-1.31,0-2.3,0.1-2.96,0.22C9.41,8.59,9.2,8.84,9.2,9.13V19.09z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.19,41.08H35c-0.52,0-0.89-0.5-0.75-1l5.59-19.37c0.22-0.75,1.28-0.75,1.5,0l5.59,19.37 C47.08,40.59,46.7,41.08,46.19,41.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.44,45.81h-11.7c-0.43,0-0.78-0.35-0.78-0.78v-2.21c0-0.43,0.35-0.78,0.78-0.78h11.7 c0.43,0,0.78,0.35,0.78,0.78v2.21C47.22,45.46,46.87,45.81,46.44,45.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.8,29.99c3.9-1.43,6.68-5.02,7.09-9.22l0.04-0.38l-1.9-0.19l-0.39,0.02l-0.04,0.38 c-0.32,3.27-2.52,6.1-5.6,7.23l-0.8,0.29l0.79,2.15L23.8,29.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.51,33.34c5.21-1.91,8.93-6.71,9.47-12.23l0.05-0.47l-2.28-0.23l-0.05,0.46 c-0.46,4.65-3.59,8.7-7.98,10.31l-0.98,0.36l0.79,2.15L24.51,33.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.07,20.61l-2.02-0.21L35,20.9c-0.62,6.26-4.84,11.71-10.75,13.87l-1.16,0.43l0.65,1.76l0.13,0.27h0.27 l0.92-0.31c6.71-2.46,11.51-8.65,12.23-15.76l0.02-0.3L37.07,20.61z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.847311f77dad2fc35d91a4f400f1539c.svg";
export { ForwardRef as ReactComponent };